import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { ServicosService } from "../../../services/api/Servicos/ServicosService"
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { faChevronLeft, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfiguracoesSistemaPrincipal from "../ConfiguracoesSistemaPrincipal";

const ServicosDados = () => {

    const { idServico } = useParams()
    const [servico, setServico] = useState(null)
    console.log(idServico)
    useEffect(() => {

        const fetchData = async () => {
            const res = await ServicosService.getById(idServico)
            console.log(res)
            if (res.success) {
                setServico(res.data);
            } else {
                setServico(null)
            }

        }

        fetchData()
    }, [])

    return (

        <>
           <ConfiguracoesSistemaPrincipal>
                <h3 className="text-info"> Serviços
                    <Button variant="danger" size="sm" style={{ marginLeft: '15px' }} href="/admin/configuracoes/servicos"><FontAwesomeIcon icon={faChevronLeft} /> Voltar</Button>
                </h3>
                <hr></hr>
                <Container fluid id="servico-header">
                    <Row>

                    </Row>
                    <Row>
                        <Col>
                            <h4 className="text-default"><span className="mr-10">{servico?.nome} {servico?.sobrenome} </span>
                            <Button variant="primary" size="sm" href={'/admin/configuracoes/servicos/cadEdit/' + idServico}><FontAwesomeIcon icon={faPenToSquare} /> Editar</Button>

                            </h4>

                        </Col>
                        <Col>
                            <div>
                                <label className="text-default">Observações:</label> {servico?.obervacoes}
                            </div>
                           
                        </Col>
                    </Row>
                </Container>



           </ConfiguracoesSistemaPrincipal>

        </>


    )
}

export default ServicosDados;